export enum ConditionType {
    None = 0,
    Date = 1,
    Friend = 2,
    Sibling = 3,
    OldCustomer = 4,
}
